// import {Nav, Navbar, Container} from 'react-bootstrap';

function Footer(){
  return(
    <>
    {/* <Navbar bg="dark" variant="dark" fixed="bottom" >
        <Container>
          <Navbar.Brand href="#home">To&middot;Do</Navbar.Brand>
          <Nav className="me-auto">
            <Nav.Link href="/">Home</Nav.Link>
            <Nav.Link href="/About">About</Nav.Link>
            <Nav.Link href="/List">To&middot;Do List</Nav.Link>
            <Nav.Link href="/Form">Manage Tasks</Nav.Link>
          </Nav>
        </Container>
    </Navbar> */}
  </>
  )

}

export default Footer;